import 'ui-core/plugins/fancybox/js/jquery.fancybox.external.js';
// this code was moved from table-of-content.js
(function () {
    UX.fancybox = abstractPreviewZoom => {
        if (abstractPreviewZoom.length) {
            abstractPreviewZoom.forEach(item => {
                item.addEventListener('keydown', e => {
                    e.stopPropagation();
                    let keycode = e.keyCode ? e.keyCode : e.which;
                    if (keycode === 13 || keycode === 27) {
                        abstractPreviewZoom.forEach(item => {
                            item.removeAttribute('attrName');
                            item.setAttribute('success', 'true');
                        });
                        e.target.setAttribute('data-lastFocus', 'true');
                    }
                });
            });

            $(abstractPreviewZoom).fancybox({
                helpers: {
                    title: null,
                },
                afterShow: function (e) {
                    setTimeout(function () {
                        const fancyboxClose = document.querySelector('.fancybox-close');
                        fancyboxClose.focus();
                    });
                },
            });
        }
    };

    UX.fancyboxClose = e => {
        if (e.target?.classList?.contains('fancybox-close')) {
            let keycode = e.keyCode ? e.keyCode : e.which;
            e.preventDefault();
            if (keycode === 13 || keycode === 27) {
                const abstractLastFocus = document.querySelector('[data-lastFocus]');
                $.fancybox.close();
                abstractLastFocus?.focus();
            } else if (keycode === 9 || keycode === 16) {
                e.preventDefault();
                e.target.focus();
            }
        }
    };
})();
